module.exports = __webpack_public_path__ + "static/media/aigoo.24b70810.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sites/aigoo.png
// module id = 320
// module chunks = 0